import { NgTemplateOutlet, UpperCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbDate, NgbDateStruct, NgbDatepickerModule, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { ToFixedPipe } from '@zero/shared/ui-pipes';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { BootstrapTimeService } from '@zero/shared/util-bootstrap-time';
import { TradingTimesService } from '@zero/trade/domain';
import { ProtectOrderBase } from '@zero/trade/feature-trade/base';
import { MAX_ORDER_VALIDITY_DAYS } from 'constants/shared-constants';
import { commonRoutes } from 'constants/web-app-constants';
import { take } from 'rxjs';

@Component({
  selector: 'trade-protect-order',
  templateUrl: './protect-order.component.html',
  styleUrls: ['./protect-order.component.scss'],
  imports: [TranslocoPipe, FormsModule, RouterLink, NgbDatepickerModule, NgTemplateOutlet, ToFixedPipe, ButtonComponent, UpperCasePipe],
})
export class ProtectOrderComponent extends ProtectOrderBase implements OnInit {
  @Input() public isProtectPositionMode = false;
  @Output() public cancelProtectPositionMode = new EventEmitter<void>();

  public readonly commonRoutes = commonRoutes;
  public datePickerMin?: NgbDateStruct;
  public datePickerMax?: NgbDateStruct;

  #datepickerClosed = true;
  readonly #tradingTimesService = inject(TradingTimesService);
  readonly #bootstrapTimeService = inject(BootstrapTimeService);

  ngOnInit() {
    this.#tradingTimesService.initHolidays();
  }

  public openDatepicker(_ev: FocusEvent, datepicker: NgbInputDatepicker, input: HTMLInputElement): void {
    if (datepicker && !datepicker.isOpen() && this.#datepickerClosed) {
      this.#datepickerClosed = false;
      datepicker.open();
      datepicker.closed.pipe(take(1)).subscribe(() => {
        Promise.resolve().then(() => {
          this.#datepickerClosed = true;
          if (typeof input?.blur === 'function') {
            input.blur();
          }
        });
      });
    }
  }

  public markDisabledDates(): (date: NgbDate, current: unknown) => boolean {
    return (date: NgbDate) => {
      const utcDateTime = this.#bootstrapTimeService.getCurrentLocalDateTimeOffsetAdjustedFrom(date);
      return this.#tradingTimesService.isWeekend(utcDateTime) || this.#tradingTimesService.isHoliday(utcDateTime);
    };
  }

  protected override setValidity(): void {
    const min: Date = this.#tradingTimesService.getGermanTodayDate();
    this.datePickerMin = {
      day: min.getDate(),
      month: min.getMonth() + 1,
      year: min.getFullYear(),
    };

    const max = new Date(min);
    max.setDate(max.getDate() + MAX_ORDER_VALIDITY_DAYS);
    this.datePickerMax = {
      day: max.getDate(),
      month: max.getMonth() + 1,
      year: max.getFullYear(),
    };

    const preset = this.#tradingTimesService.getValidToDatePreset(this.#tradingTimesService.getCurrentLocalDateTime(), 5);
    this.form.validity = new Date(Date.UTC(preset.getFullYear(), preset.getMonth(), preset.getDate()));
  }
}
